import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { post } from "../networking/RequestService";
import { getCitiesForSelect, getCountriesForSelect } from "../app/functions/util";
import { actions } from "../app/redux/appRedux";

const useLocationOptions = () => {
    const [countryOptions, setCountryOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { dynamicSchemaDataManagement } = useSelector((state) => state.app);
    const dispatch = useDispatch();

    const fetchCampaignDynamicSchema = () => {
        if (!dynamicSchemaDataManagement) {
            let requestObj = {
                fn: "getCampaignDynamicSchemaAllFields",
                module: "data management",
            };

            post(requestObj).then(({ data: { dynamicSchemaFields } }) => {
                dispatch(actions.setDynamicSchemaDataManagement(dynamicSchemaFields));
                updateCountryOptions(dynamicSchemaFields);
            });
        } else {
            updateCountryOptions(dynamicSchemaDataManagement);
        }
    };

    const updateCountryOptions = (schemaData) => {
        const countries = getCountriesForSelect(schemaData)?.filter((country) => country.value !== "LVT");
        setCountryOptions(countries || []);
        setIsLoading(false);
    };

    const updateCityOptions = (countryValue) => {
        setCityOptions(countryValue ? getCitiesForSelect(dynamicSchemaDataManagement, countryValue) : []);
    };

    useEffect(() => {
        fetchCampaignDynamicSchema();
    }, []);

    return { countryOptions, cityOptions, updateCityOptions, isLoading };
};

export default useLocationOptions;
